import groupBy from 'lodash/groupBy';
import orderBy from 'lodash/orderBy';
import uniq from 'lodash/uniq';
import filter from 'lodash/filter';
import qtsCostMapping from '../qtsCostMapping';

// SET Turn-Key Omnibus steps
export const ieSteps = {
  SURVEY_LIST: 'SURVEY_LIST',
  SURVEY_SETTINGS: 'SURVEY_SETTINGS',
  TARGET: 'TARGET',
  QUESTIONS: 'QUESTIONS',
  DICTIONARY: 'DICTIONARY',
  SUMMARY: 'SUMMARY',
  SURVEY_DETAILS: 'SURVEY_DETAILS',
  CREATE_SURVEY: 'CREATE_SURVEY',
};

// ====================== Survey Questions and Options ====================
// get survey questions and options
export const _getSurveyQnO = metaData => {
  const questionDtoList = [];
  let options = [];

  metaData.map(item => {
    options = [...options, ...item.optionDtoList];

    const { optionDtoList, ...withoutOptions } = item;
    // console.log();
    questionDtoList.push(withoutOptions);
    return false;
  });

  return new Promise(res => {
    res({
      options,
      questions: questionDtoList,
    });
  });
};

const _validateSpecialChar = a => {
  const re = /^[a-zA-Z0-9 ]*$/;
  const notBlank = a.trim();
  const noSpeical = re.test(a);
  if (notBlank && noSpeical) {
    return true;
  }
  return false;
};

export const _getIeDictionary = (q, o) => {
  const groupedQuestions = q.length > 0 ? groupBy(q, 'questionId') : null;
  const groupedOptions = o.length > 0 ? groupBy(o, 'questionId') : null;
  const dictionary = {};

  dictionary[q[0].questionId] = {
    options: {
      column: {},
      row: {},
    },
    question: q[0],
  };

  const optionsRowCol = {};
  if (groupedOptions) {
    Object.keys(groupedOptions).map(qid => {
      const column = {};
      const row = {};
      groupedOptions[qid].map(option => {
        if (option.subQuestionId && option.subQuestionShortDesc) {
          row[option.subQuestionId] = option;
        }
        column[option.optionId] = option;
        return false;
      });
      optionsRowCol[qid] = { column, row };
      return false;
    });

    Object.keys(groupedOptions).map(qid => {
      dictionary[qid] = {
        options: optionsRowCol[qid],
        question: groupedQuestions[qid][0],
      };
      return false;
    });
  }

  const specialChar = [];
  const maxLength = [];

  Object.keys(dictionary).map((qid, index) => {
    const question = dictionary[qid].question;
    const qOptions = dictionary[qid].options;
    const qText = question.shortDescription;
    if (!_validateSpecialChar(qText)) {
      if (qid === '0') {
        specialChar.push(`SN_${index}_${qid}`);
      } else {
        specialChar.push(`Q_${index}_${qid}`);
      }
    }
    if (qText.length > 35) {
      if (qid === '0') {
        maxLength.push(`SN_${index}_${qid}`);
      } else {
        maxLength.push(`Q_${index}_${qid}`);
      }
    }

    Object.keys(qOptions.column).map((oid, oIndex) => {
      const option = qOptions.column[oid];
      const text = option.shortDescription;
      if (!_validateSpecialChar(text)) {
        specialChar.push(`O_${oIndex}_${qid}_${oid}`);
      }
      if (text.length > 35) {
        maxLength.push(`O_${oIndex}_${qid}_${oid}`);
      }
      return false;
    });

    Object.keys(qOptions.row).map((subQid, oIndex) => {
      const option = qOptions.row[subQid];
      const text = option.subQuestionShortDesc;
      if (!_validateSpecialChar(text)) {
        specialChar.push(`sQ_${oIndex}_${qid}_${subQid}`);
      }
      if (text.length > 35) {
        maxLength.push(`sQ_${oIndex}_${qid}_${subQid}`);
      }
      return false;
    });
    return false;
  });

  const initialError = {
    specialChar,
    maxLength,
  };

  return { dictionary, initialError };
};

export const _updateDictionaryText = (text, type, currentObj, prevQO) => {
  let questions = [...prevQO.questions];
  let options = [...prevQO.options];

  if (type === 'Q' || type === 'SN') {
    questions = questions.map(obj => {
      if (obj.questionId === currentObj.questionId) {
        const updated = text.trim() !== obj.description;
        return { ...obj, shortDescription: text, updated };
      }
      return obj;
    });
  } else {
    options = options.map(obj => {
      let oObj = obj;
      if (type === 'O' && obj.optionId === currentObj.optionId) {
        let updated = text.trim() !== oObj.description;
        if (oObj.subQuestionDesc !== oObj.subQuestionShortDesc) {
          updated = true;
        }
        oObj = { ...oObj, shortDescription: text, updated };
      }
      if (type === 'sQ' && obj.subQuestionId === currentObj.subQuestionId) {
        let updated = text.trim() !== oObj.subQuestionDesc;
        if (oObj.description !== oObj.shortDescription) {
          updated = true;
        }
        oObj = { ...oObj, subQuestionShortDesc: text, updated };
      }
      return oObj;
    });
  }
  return ({ questions, options });
};

// ================ Targetting Criteria Calculations =======================

export const _splitExpression = expression => {
  if (expression) {
    const splitWithAnd = expression.split(' )) AND (( ');
    let splitWithOr = [];
    splitWithAnd.map(c => {
      const splited = c.split(') OR (');
      splitWithOr = [...splitWithOr, ...splited];
      return false;
    });
    const splitedData = [];
    splitWithOr.map(trimed => {
      const replaceBrackets = trimed.replace(/\(|\)/g, '');
      splitedData.push(replaceBrackets.trim());
      return false;
    });
    return uniq(splitedData);
  }
  return false;
};

const _sortMapping = array => {
  return orderBy(array, o => o.orderId, ['asc']);
};

const _getSortedMapping = array => {
  const sortedWithOption = array.map(item => {
    return {
      ...item,
      options: _sortMapping(item.options),
    };
  });
  return _sortMapping(sortedWithOption);
};

export const _getKeywordsTree = (keywordMapping, expression = []) => {
  const keywords = _getSortedMapping(keywordMapping);
  const tree = [];
  let childNodeId = 1;

  keywords.map((q, i) => {
    const obj = {
      ...q,
      qid: q.prodegeQid,
      title: q.qtext,
      qNode: i + 1,
      isOpen: false,
    };

    const options = [];
    q.options.map(k => {
      const isActive = expression.includes(k.keyword);
      const opObj = {
        ...k,
        title: k.otext,
        qTitle: q.qtext,
        allOids: k.prodegeOIds,
        oid: k.prodegeOIds[0],
        qid: q.prodegeQid,
        isActive,
        isSelected: false,
        oNode: childNodeId,
        qNode: i + 1,
      };
      childNodeId += 1;
      options.push(opObj);
      return null;
    });

    obj.options = options;

    tree.push(obj);
    return null;
  });
  return tree;
};

// Generate expressions
export const _createExpression = (tc = []) => {
  if (tc.length > 0) {
    const gq = groupBy(tc, 'qid');
    const exp = [];
    Object.keys(gq).map(qid => {
      const key = gq[qid].map(op => op.keyword);
      const d = `( ${key.join(' ) OR ( ')} )`;
      exp.push(d);
      return false;
    });
    const finalExpression = `(${exp.join(') AND (')})`;
    return finalExpression;
  }
  return '';
};

export const _createFeasibilityExpression = tc => {
  const tcGroup = groupBy(tc, 'qid');
  const expression = [];
  Object.keys(tcGroup).map(key => {
    const prod = tcGroup[key];
    let precodes = [];
    prod.map(item => {
      precodes = [...precodes, ...item.allOids];
      return false;
    });
    expression.push({
      operator: 'OR',
      precodes,
      question_id: Number(key),
    });
    return false;
  });
  return expression;
};

export const _createTargetingCriteria = tc => {
  const tcGroup = groupBy(tc, 'qid');
  const exp = [];
  Object.keys(tcGroup).map(key => {
    tcGroup[key].map(item => {
      exp.push(`${item.qTitle} - ${item.title}`);
      return false;
    });
    return false;
  });
  return exp.length > 0 ? exp.join(' / ') : '';
};

// generate default expressions
export const _getDefaultExpression = targetingCriteria => {
  const tc =
    targetingCriteria.length > 0 &&
    targetingCriteria.find(item => item.title === 'GENDER');
  const expression = _createExpression(tc.options);
  const feasibilityExpression = _createFeasibilityExpression(tc.options);
  return {
    defaultExp: expression,
    defaultFeasibilityExp: feasibilityExpression,
  };
};

export const _getActiveTc = (tc, allTc) => {
  const targetingCriteria = [];
  const selectedTc = [];
  allTc.map(item => {
    let options = item.options;
    const currentItem = filter(tc, t => t.qNode === item.qNode);
    options = options.map(op => {
      const currentOptions = filter(currentItem, t => t.oNode === op.oNode);
      const isActive = currentOptions.length > 0;
      const data = {
        ...op,
        isSelected: false,
        isActive: isActive || op.isActive,
      };
      if (isActive) {
        selectedTc.push(currentOptions[0]);
      }
      return data;
    });
    targetingCriteria.push({
      ...item,
      options,
    });
    return false;
  });
  return { targetingCriteria, selectedTc };
};

export const _getActivateMultipleTc = (allTc, qNode, range, isShiftClick) => {
  const targetingCriteria = [];
  allTc.map(item => {
    let options = item.options;
    options = options.map(op => {
      const data = isShiftClick
        ? {
          ...op,
          isSelected: false,
        }
        : {
          ...op,
        };
      if (item.qNode === qNode && range.includes(op.oNode) && !data.isActive) {
        data.isSelected = !data.isSelected;
      }
      return data;
    });
    targetingCriteria.push({
      ...item,
      options,
    });
    return false;
  });
  return targetingCriteria;
};

export const _updateTc = (allTc, to) => {
  const targetingCriteria = allTc.map(item => {
    const options = item.options.map(op => {
      const data = {
        ...op,
        isSelected: false,
        isActive: op.oNode === to.oNode ? false : op.isActive,
      };
      return data;
    });
    return {
      ...item,
      options,
    };
  });
  return targetingCriteria;
};

export const _setSelectedTc = (keywordMapping, splitedExp) => {
  let targetingCriteria = _getKeywordsTree(keywordMapping);
  const selectedTc = [];
  if (splitedExp && splitedExp.length > 0) {
    targetingCriteria = _getKeywordsTree(keywordMapping, splitedExp);
    targetingCriteria.map(q => {
      q.options.map(op => {
        if (op.isActive) {
          selectedTc.push(op);
        }
        return false;
      });
      return false;
    });
  }
  return { targetingCriteria, selectedTc };
};


// ================ STUDIES =======================
export const _sortStudy = study => {
  // sorting study by field end date;
  if (study.length > 0) {
    return orderBy(study, o => new Date(o.fe), ['desc']);
  }
  return [];
};


// ================
// Calculations -
// Sample Size - Incidence Rate - Estimated Cost
// =======================

const increaseBy10Percent = value => {
  return value * 1.1;
};

export const _calculateSampleSize = (
  inputValue,
  samplewgtd,
  completesEstimate
) => {
  const oneTenth = samplewgtd.intab / 10;
  const halfOfOneSampleWgtd = Math.round(oneTenth / 50) * 50;

  const isLessThen500 = halfOfOneSampleWgtd < 500;
  const ismoreThenEqual300 = halfOfOneSampleWgtd >= 300;
  const ismoreThen300 = halfOfOneSampleWgtd > 300;
  const islessThen300 = halfOfOneSampleWgtd < 300;
  const ismoreThenEqual500 = halfOfOneSampleWgtd >= 500;
  const ismoreThen2000 = halfOfOneSampleWgtd > 2000;
  const suggestedSample = ismoreThen2000 ? 2000 : halfOfOneSampleWgtd;

  let sampleToDisplay = inputValue;

  if (completesEstimate > increaseBy10Percent(oneTenth)) {
    if (isLessThen500 && ismoreThenEqual300) {
      sampleToDisplay = inputValue >= 500 ? inputValue : 500;
    } else {
      sampleToDisplay =
        inputValue > suggestedSample ? inputValue : suggestedSample;
    }
  } else if (ismoreThenEqual500) {
    sampleToDisplay = halfOfOneSampleWgtd;
  } else if (isLessThen500 && ismoreThen300) {
    sampleToDisplay = 500;
  } else if (islessThen300) {
    sampleToDisplay = Math.round(samplewgtd.intab / 500) * 50;
  }

  return sampleToDisplay;
};

// COST Calculations
// 1) qtsCostMapping from 'qtsCostMapping.js'
// 2) incidenceRate that was calculated on calculateIncidenceRate.js
// 2) sampleToDisplay that was calculated on calculateSampleSize.js

export const _calculateCost = (incidenceRate = 100, sampleToDisplay = 2000) => {
  let sampleSize = sampleToDisplay;
  let diff = 0;
  if (sampleSize > 2000) {
    diff = sampleSize - 2000;
    sampleSize = 2000;
  }
  let cost = 0;
  const slab = qtsCostMapping.slabs
    .filter(e => e.minir <= incidenceRate && e.maxir >= incidenceRate)
    .filter(
      f =>
        f.minsample <= sampleSize && f.maxsample >= sampleSize
    );

  if (slab !== undefined && slab.length > 0) {
    cost = slab[0].flat;
  }
  cost = diff > 0 ? cost + (diff * qtsCostMapping.additionalRate) : cost;

  return String(cost);
};


// ======================
// Duplicate survey name check
// Requred: surveyList
// =======================

export const _isSurveyNameDuplicate = (name, surveyId, surveyList = []) => {
  let filteredSurveyList = surveyList;
  if (surveyId) {
    filteredSurveyList = surveyList.filter(
      survey => survey.surveyId !== surveyId
    );
  }
  const filteredSurvey = filteredSurveyList.filter(item => {
    const surveyName = item.surveyName.toUpperCase().replace(/\s/g, '');
    const newSurveyName = name.toUpperCase().replace(/\s/g, '');
    return surveyName === newSurveyName && item.surveyid !== surveyId;
  });

  if (filteredSurvey.length <= 0) {
    return false;
  }

  return true;
};
